<section class="section py-6">
    <div class="columns">
      <div class="column header-title-page">
        <h2 class="title-header">Matriz de limpieza</h2>
        <!-- <button class="button is-primary" (click)="openModal()">Nueva regla de limpieza</button> -->
      </div>
    </div>

    <div class="columns">
      <div class="column is-6">
        <div class="field">
          <label class="label">Buscar</label>
          <p class="control has-icons-left">
            <input class="search-bar input" type="text" placeholder="Buscar..."[(ngModel)]="filters.search.value"
            (keyup.enter)="onFilter()">
            <span class="icon is-left">
              <fa-icon class="icon-search" [icon]="faMagnifyingGlass"></fa-icon>
            </span>
          </p>
        </div>
      </div>
    </div>
  </section>
  @if (isLoading) {
    <section class="section py-1">
        <app-spinner></app-spinner>
      </section>
  } @else {
    <section class="section py-1" >
        <div class="columns has-background-white">
          <div class="column">
            <div class="columns">
              <div class="column p-5">
                @if (cleaningMatrix) {
                    <div class="table-cleaning-rules">
                        <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="cleaningMatrixFiltered"
                          (onSelectRow)="openModal($event)" (onDeleteItem)="delete($event)"></app-generic-table>
                    </div>
                }    
              </div>
            </div>
          </div>
        </div>
      </section>
  }
  <!-- <div class="modal" [ngClass]="{'is-active': isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <form [formGroup]="form" (ngSubmit)="onSave()">
        <header class="modal-card-head">
          @if (isCreating) {
              <p class="modal-card-title" >Nueva regla de limpieza</p>
          } @else {
              <p class="modal-card-title" >Editando regla limpieza: {{ form.value.id }}</p>
          }
          <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Id</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Id" formControlName="id">
                </div>
              </div>
              <div class="field">
                <label class="label">Tipo</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Tipo" formControlName="type">
                </div>
              </div>
              <div class="field">
                <label class="label">Limpieza</label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="type">
                        @for (cleaning of cleanings; track cleaning) {
                            <option [value]="cleaning.type">{{ cleaning.type }} - {{
                                cleaning.description }}
                            </option>
                        }    
                    </select>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Producto anterior</label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="lastProduct">
                        @for (product of products; track product) {
                            <option [value]="product.number">{{ product.number }} - {{
                                product.description }}
                              </option>
                        }
                    </select>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Producto posterior</label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="nextProduct">
                        @for (product of products; track product) {
                            <option [value]="product.number">{{ product.number }} - {{
                                product.description }}
                              </option>
                        }
                    </select>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Tiempo mínimo</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Tiempo mínimo" formControlName="minTime">
                </div>
              </div>
              <div class="field">
                <label class="label">Tiempo máximo</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Tiempo máximo" formControlName="maxTime">
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
          <button type="button" class="button" (click)="closeModal()">Cancelar</button>
          <button type="submit" class="button is-primary" [disabled]="!form.valid">
            @if (isLoading) {
                <fa-icon [icon]="faSpinner" ></fa-icon>
            } @else {
                <span>Guardar</span>
            }
          </button>
        </footer>
      </form>
    </div>
  </div> -->